/**
 * Footer component
 */

import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-bg-secondary border-t border-gray-800 py-8 mt-auto">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-lg font-bold text-gradient mb-2">Patch Manager</h3>
            <p className="text-gray-400 text-sm mb-4">
              Enterprise software version tracking and vulnerability management platform.
              Track 44+ software products with automated patch discovery.
            </p>
            <p className="text-xs text-gray-500">
              Built with Cloudflare Workers, D1, and R2
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold text-gray-300 mb-3">Product</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/catalog" className="text-gray-400 hover:text-cyber-blue-400 transition-colors">
                  Software Catalog
                </Link>
              </li>
              <li>
                <Link to="/api-keys" className="text-gray-400 hover:text-cyber-blue-400 transition-colors">
                  API Access
                </Link>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyber-blue-400 transition-colors">
                  Documentation
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold text-gray-300 mb-3">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="text-gray-400 hover:text-cyber-blue-400 transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyber-blue-400 transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyber-blue-400 transition-colors">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © {currentYear} Patch Manager. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-gray-500">Powered by Cloudflare</span>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
              <span className="text-xs text-gray-400">All systems operational</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
